// activeStoreId is persisted directly to localStorage by userStoresSlice's
// setActiveStore reducer, so plain (non-hook) API functions can read it here
// without needing access to the Redux store instance.
export const getActiveStoreId = () => localStorage.getItem('activeStoreId') || undefined;

// storeId is required on every menu-domain create request. Use this instead
// of getActiveStoreId() at any call site that sends one, so a missing store
// aborts before the request goes out instead of being silently omitted.
export const requireActiveStoreId = () => {
  const storeId = getActiveStoreId();
  if (!storeId) {
    throw new Error('Select a store before making changes to the menu.');
  }
  return storeId;
};
